export const normalizeEmptyFields = (data: any) => {
  const result: any = {};

  for (const key in data) {
    const value = data[key];

    if (Array.isArray(value)) {
      result[key] = value.map(item => {
        if (typeof item === 'object' && item !== null) {
          return normalizeEmptyFields(item);
        } else {
          return item ?? "";
        }
      });
    } else if (["number", "range", "date", "time"].includes(key)) {
      result[key] = value ?? null;
    } else if (key === "file_upload") {
      result[key] = value;
    } else if (value === null || value === undefined) {
      result[key] = "";
    } else if (typeof value === "object" && value !== null) {
      result[key] = normalizeEmptyFields(value);
    } else {
      result[key] = value;
    }
  }

  return result;
};
